export const indexSalesForcesPath: string = "/salesForce";
